import './DatasetStatusBadge.scss';
import { useTranslator } from '@Localization';
import classNames from 'classnames';
import { ReactElement } from 'react';
import { DatasetStatus } from '../../../../__legacy__/modules/datasets/datasetStatus.model';
import { StatusBadge } from '../../../../design/statusBadge/StatusBadge';

interface IProps {
  datasetStatus: DatasetStatus;
}

export const DatasetStatusBadge = ({ datasetStatus }: IProps): ReactElement => {
  const { t } = useTranslator();
  const getText = (): string => {
    switch (datasetStatus) {
      case 'Draft':
        return t('dataset_status_Draft');
      case 'Published':
        return t('dataset_status_Published');
      case 'None':
      case 'Uploading':
      case 'PublishedUploading':
      default:
        return t('dataset_status_Uploading');
    }
  };

  return (
    <StatusBadge
      className={classNames('dataset-status-badge', datasetStatus.toLowerCase())}
      text={getText()}
    />
  );
};
